import { xmllib } from "./xml-lib/xml-lib.js";

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

function formatDate(date) {
  return [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join("/");
}

const Search = {
  bar: {
    elem: {
      searchBarParent: () => {
        return document.getElementById("search-bar");
      },
      searchBar: () => {
        return document.getElementById("search");
      },
      predictiveResults: () => {
        return document.getElementById("search-bar-predictive-results");
      },
      results: () => {
        return document.getElementById("search-bar-results");
      },
    },
    rest: {
      uri: (string) => {
        string +=
          "predictive-search/search?title=" +
          encodeURIComponent(Search.bar.elem.searchBar().value) +
          "&per_page=1";
        return string;
      },
    },
    predictive: {
      get: (string) => {
        Search.bar.elem.searchBar().value = Search.bar.elem
          .searchBar()
          .value.toLowerCase();
        string = "";
        xmllib.get(Search.bar.predictive.process, Search.bar.rest.uri(string));
      },
      process: (success, data) => {
        if (success !== true) {
          console.error("Failed to retrieve Results");
          return false;
        }

        if (Search.bar.elem.searchBar().value.length == 0) {
          Search.bar.elem.predictiveResults().innerHTML = "Search";
          return false;
        }

        if (!data.length) {
          Search.bar.elem.predictiveResults().innerHTML = "";
          return false;
        }

        // if (!data[0].post_title.includes(Search.bar.elem.searchBar().value)) {
        //   Search.bar.elem.predictiveResults().innerHTML = "";
        //   return false;
        // }

        Search.bar.elem.predictiveResults().innerHTML =
          data[0].post_title.toLowerCase();
      },
    },
    init: () => {
      Search.bar.elem.searchBar().addEventListener("keyup", (event) => {
        // Search.bar.predictive.get();

        if (Search.bar.elem.searchBar().value.length == 0) {
          Search.bar.elem.predictiveResults().innerHTML = "Search";
        }

        if (Search.bar.elem.searchBar().value.length == 1) {
          Search.bar.elem.predictiveResults().innerHTML = "";
        }
      }); // Entry Point, Start Typing

      Search.bar.elem.searchBar().addEventListener("keydown", (event) => {
        if (event.key == "Tab") {
          event.preventDefault();

          if (Search.bar.elem.searchBar().value.length > 0) {
            Search.bar.elem.searchBar().value = Search.bar.elem
              .predictiveResults()
              .innerHTML.replace(/&amp;/g, "&");
          }
        }
      });

      let typingTimer;
      let doneTypingInterval = 300;
      let myInput = Search.bar.elem.searchBar();

      myInput.addEventListener("keyup", (event) => {
        clearTimeout(typingTimer);
        if (myInput.value) {
          typingTimer = setTimeout(() => {
            if (Search.bar.elem.searchBar().value.length == 0) {
              Search.bar.elem.predictiveResults().innerHTML = "Search";
            }

            Search.bar.predictive.get();
          }, doneTypingInterval);
        }
      });

      Search.bar.elem.searchBar().addEventListener("keydown", (event) => {
        if (event.key == "Enter") {
          event.preventDefault();

          if (Search.bar.elem.searchBar().value.length > 0) {
            window.location.href =
              window.location.protocol +
              "//" +
              window.location.host +
              "/search?q=" +
              encodeURIComponent(Search.bar.elem.searchBar().value);
          }
        }
      });
    },
  },
  page: {
    elem: {
      searchBarParent: () => {
        return document.getElementById("sp-search-bar");
      },
      searchBar: () => {
        return document.getElementById("sp-search");
      },
      predictiveResults: () => {
        return document.getElementById("sp-search-bar-predictive-results");
      },
      projectResults: () => {
        return document.getElementById("project-results");
      },
      newsResults: () => {
        return document.getElementById("news-results");
      },
      insightResults: () => {
        return document.getElementById("insights-results");
      },
      teamResults: () => {
        return document.getElementById("people-results");
      },
      pagesResults: () => {
        return document.getElementById("pages-results");
      },
    },
    query: {
      get: () => {
        // New Performant Way of retrieving Search Parameters
        const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        });

        console.log(params.q);
        return params.q;
      },
      set: () => {},
    },
    rest: {
      uri: (string) => {
        string +=
          "predictive-search/search?title=" +
          encodeURIComponent(Search.page.elem.searchBar().value);
        return string;
      },
      project: () => {
        let string =
          "project?subtype=project&search=" +
          encodeURIComponent(Search.page.elem.searchBar().value) +
          "&per_page=10" +
          "&_embed" +
          "&_fields=fimg_url,title,slug,acf,link,excerpt,_links.wp:featuredmedia";

        //"&_fields[]=title&_fields[]=slug&_fields[]=acf&_fields[]=link&_fields[]=excerpt&_fields[]=fimg_url";

        return string;
      },
      news: () => {
        let string =
          "posts?subtype=posts&search=" +
          encodeURIComponent(Search.page.elem.searchBar().value) +
          "&per_page=4" +
          "&_embed" +
          "&_fields=fimg_url,title,slug,acf,link,excerpt,date,_links.wp:featuredmedia";

        console.log(string);
        return string;
      },
      insight: () => {
        let string =
          "insight?subtype=insight&search=" +
          encodeURIComponent(Search.page.elem.searchBar().value) +
          "&per_page=20" +
          "&_embed" +
          "&_fields=fimg_url,title,slug,acf,link,excerpt,_links.wp:featuredmedia";

        console.log(string);
        return string;
      },
      team: () => {
        let string =
          "team?subtype=team&search=" +
          encodeURIComponent(Search.page.elem.searchBar().value) +
          "&per_page=10" +
          "&_embed" +
          "&_fields=fimg_url,title,slug,acf,link,excerpt,_links.wp:featuredmedia";

        console.log(string);
        return string;
      },
      pages: () => {
        let string =
          "pages?subtype=pages&search=" +
          encodeURIComponent(Search.page.elem.searchBar().value) +
          "&per_page=100" +
          "&_embed" +
          "&_fields=fimg_url,title,slug,acf,link,excerpt,_links.wp:featuredmedia";

        console.log(string);
        return string;
      },
    },
    predictive: {
      get: (string) => {
        Search.page.elem.searchBar().value = Search.page.elem
          .searchBar()
          .value.toLowerCase();
        string = "";
        xmllib.get(
          Search.page.predictive.process,
          Search.page.rest.uri(string)
        );
      },
      process: (success, data) => {
        if (success !== true) {
          console.error("Failed to retrieve Results");
          return false;
        }

        if (Search.page.elem.searchBar().value.length == 0) {
          Search.page.elem.predictiveResults().innerHTML = "Search";
          return false;
        }

        if (!data.length) {
          Search.page.elem.predictiveResults().innerHTML = "";
          return false;
        }

        // if (!data[0].post_title.includes(Search.page.elem.searchBar().value)) {
        //   Search.page.elem.predictiveResults().innerHTML = "";
        //   return false;
        // }

        console.log("predictive success");

        Search.page.elem.predictiveResults().innerHTML =
          data[0].post_title.toLowerCase();
      },
    },
    results: {
      get: () => {
        xmllib.get(Search.page.results.project, Search.page.rest.project());
        xmllib.get(Search.page.results.news, Search.page.rest.news());
        xmllib.get(Search.page.results.insight, Search.page.rest.insight());
        xmllib.get(Search.page.results.team, Search.page.rest.team());
        xmllib.get(Search.page.results.pages, Search.page.rest.pages());
      },
      project: (success, data) => {
        // Specific to Project Results

        let renderHTML = "";

        if (data.length == 0) {
          renderHTML +=
            "<span class='search-no-result fs-30'><span>There are no results for this section</span></span>";
        }

        if (!data.length == 0) {
          data.forEach((dat) => {
            renderHTML += `<div class="a inherit-link">`;

            if (Object.keys(dat["_links"]).length > 0) {
              renderHTML += `<img src="${dat._embedded["wp:featuredmedia"][0]["media_details"]["sizes"]["full"].source_url}" loading="lazy">`;
            }

            renderHTML += `<h2 class="fs-30">${dat.title.rendered}</h2>`;

            renderHTML += `<span class="fs-16">${dat.acf.project_location}</span>`;
            renderHTML += `<a class="screen-reader-text" href="${dat.link}">Read More</a>`;
            renderHTML += `</div>`;
          });
        }

        let html = new DOMParser().parseFromString(renderHTML, "text/html");
        html = html.getRootNode();
        Search.page.elem.projectResults().innerHTML = "";
        Search.page.elem.projectResults().append(html.body);
      },
      news: (success, data) => {
        // Specific to Project Results

        let renderHTML = "";

        if (data.length == 0) {
          renderHTML +=
            "<span class='search-no-result fs-30'><span>There are no results for this section</span></span>";
        }

        if (!data.length == 0) {
          data.forEach((dat) => {
            renderHTML += `<div class="a inherit-link search-news-article">`;

            if (Object.keys(dat["_links"]).length > 0) {
              renderHTML += `<img src="${dat._embedded["wp:featuredmedia"][0]["media_details"]["sizes"]["full"].source_url}" loading="lazy">`;
            }
            renderHTML += `<h2 class="fs-30">${dat.title.rendered}</h2>`;

            renderHTML += `<div class="fs-30">${formatDate(
              new Date(dat.date)
            )}</div>`;
            renderHTML += `<p>${dat.excerpt.rendered}</p>`;
            renderHTML += `<a class="btn button" href="${dat.link}"><span data-type="icon" data-temp="ico-plus.twig" class="ico-frame ico-plus"><span class="screen-reader-text">Open</span></span><span>Read More</span></a>`;
            renderHTML += `</div>`;
          });
        }

        let html = new DOMParser().parseFromString(renderHTML, "text/html");
        html = html.getRootNode();
        Search.page.elem.newsResults().innerHTML = "";
        Search.page.elem.newsResults().append(html.body);
      },
      insight: (success, data) => {
        // Specific to Project Results

        let renderHTML = "";

        if (data.length == 0) {
          renderHTML +=
            "<span class='search-no-result fs-30'><span>There are no results for this section</span></span>";
        }

        if (!data.length == 0) {
          renderHTML += ``;
          renderHTML += `<ul>`;
          data.forEach((dat) => {
            renderHTML += `<li class="inherit-link a item ani-fade ani-line is-animating" animation>`;
            renderHTML += `<div class="left">`;
            renderHTML += `<h3 class="fs-30 title a"><a href="${dat.link}">${dat.title.rendered}</a></h3>`;

            renderHTML += `</div>`;
            renderHTML += `<div class="right">`;
            renderHTML += `<span data-type="icon" data-temp="ico-plus.twig" class="ico-frame is-red ico-plus"><span class="screen-reader-text">Open</span></span>`;
            renderHTML += `</div>`;
            renderHTML += `</li>`;
          });
          renderHTML += `</ul>`;
          renderHTML += ``;
        }

        let html = new DOMParser().parseFromString(renderHTML, "text/html");
        html = html.getRootNode();
        Search.page.elem.insightResults().innerHTML = "";
        Search.page.elem.insightResults().append(html.body);
      },
      team: (success, data) => {
        // Specific to Project Results

        let renderHTML = "";

        if (data.length == 0) {
          renderHTML +=
            "<span class='search-no-result fs-30'><span>There are no results for this section</span></span>";
        }

        if (!data.length == 0) {
          data.forEach((dat) => {
            if (Object.keys(dat["_links"]).length > 0) {
              renderHTML += `<div class="a inherit-link">`;

              renderHTML += `<img src="${dat._embedded["wp:featuredmedia"][0]["media_details"]["sizes"]["full"].source_url}" loading="lazy">`;

              renderHTML += `<h2 class="fs-30">${dat.title.rendered} <span class="pla">${dat.acf.pnl}</span></h2>`;

              renderHTML += `<span class="fs-16">${dat.acf.position}</span>`;
              renderHTML += `<a class="screen-reader-text" href="${dat.link}">Read More</a>`;
              renderHTML += `</div>`;
            }
          });
        }

        let html = new DOMParser().parseFromString(renderHTML, "text/html");
        html = html.getRootNode();
        Search.page.elem.teamResults().innerHTML = "";
        Search.page.elem.teamResults().append(html.body);
      },
      pages: (success, data) => {
        // Specific to Project Results

        let renderHTML = "";

        if (data.length == 0) {
          renderHTML +=
            "<span class='search-no-result fs-30'><span>There are no results for this section</span></span>";
        }

        if (!data.length == 0) {
          data.forEach((dat) => {
            renderHTML += `<a href="${dat.link}">`;
            renderHTML += `${dat.title.rendered}`;
            renderHTML += `</a>`;
          });
        }

        let html = new DOMParser().parseFromString(renderHTML, "text/html");
        html = html.getRootNode();
        Search.page.elem.pagesResults().innerHTML = "";
        Search.page.elem.pagesResults().append(html.body);
      },
    },
    init: () => {
      if (!Search.page.elem.searchBar()) {
        return;
      }

      //
      if (Search.page.query.get()) {
        Search.page.elem.searchBar().value = Search.page.query.get();
        Search.page.results.get();
        Search.page.elem.predictiveResults().innerHTML = "";
      }

      let typingTimer;
      let doneTypingInterval = 3000;
      let myInput = Search.page.elem.searchBar();

      // Entry Point, Start Typing
      myInput.addEventListener("keyup", (event) => {
        clearTimeout(typingTimer);
        if (myInput.value) {
          typingTimer = setTimeout(() => {
            Search.page.results.get();
          }, doneTypingInterval);
        }
      });

      // Predictive
      let typingTimer2;
      let doneTypingInterval2 = 750;
      let myInput2 = Search.page.elem.searchBar();

      myInput2.addEventListener("keyup", (event) => {
        clearTimeout(typingTimer2);
        if (myInput2.value) {
          typingTimer = setTimeout(() => {
            if (Search.page.elem.searchBar().value.length == 0) {
              Search.page.elem.predictiveResults().innerHTML = "Search";
            }

            if (Search.page.elem.searchBar().value.length == 1) {
              Search.page.elem.predictiveResults().innerHTML = "";
            }

            Search.page.predictive.get();
          }, doneTypingInterval2);
        }
      });

      // On Tab, Autofill Search
      Search.page.elem.searchBar().addEventListener("keydown", (event) => {
        if (event.key == "Tab") {
          event.preventDefault();

          if (Search.page.elem.searchBar().value.length > 0) {
            Search.page.elem.searchBar().value = Search.page.elem
              .predictiveResults()
              .innerHTML.replace(/&amp;/g, "&");
          }
        }
      });
    },
  },
  init: () => {
    Search.bar.init();
    Search.page.init();
  },
};

export { Search as Search };
